import React, { FC } from 'react';
import { Grid, Typography } from '@mui/material';
import { SWAP_RATE_NAME_TO_PLATFORM_FEE_PERCENT, ExchangeRateName } from '@okletsplay/core';
import { SwapSummaryDto } from 'app/interfaces/dto';
import { FormatCurrency, FormatCurrencyType } from 'shared/components/Format/Currency';

type ComponentProps = SwapSummaryDto & {
  pair: ExchangeRateName;
};

export const SwapSummary: FC<ComponentProps> = ({
  totalSell,
  platformFee,
  buy,
  newBalance,
  pair,
}) => {
  const feePercent = SWAP_RATE_NAME_TO_PLATFORM_FEE_PERCENT[pair];

  return (
    <Grid container rowSpacing={1}>
      <Grid item xs={8} sm={10}>
        <Typography>You Pay Total</Typography>
      </Grid>
      <Grid item xs={4} sm={2} textAlign="right">
        <FormatCurrency {...totalSell} type={FormatCurrencyType.Crypto} />
      </Grid>
      <Grid item xs={8} sm={10}>
        <Typography>
          Platform Fee <i>({feePercent}% applied on top)</i>
        </Typography>
      </Grid>
      <Grid item xs={4} sm={2} textAlign="right">
        <FormatCurrency {...platformFee} type={FormatCurrencyType.Crypto} />
      </Grid>
      <Grid item xs={8} sm={10}>
        <Typography>You Receive</Typography>
      </Grid>
      <Grid item xs={4} sm={2} textAlign="right">
        <FormatCurrency {...buy} type={FormatCurrencyType.Crypto} />
      </Grid>
      <Grid item xs={8} sm={10}>
        <Typography>New Balance</Typography>
      </Grid>
      <Grid item xs={4} sm={2} container rowSpacing={1}>
        {newBalance.map((balance) => (
          <Grid item sm={12} key={balance.currency + balance.amount} textAlign="right">
            <FormatCurrency {...balance} type={FormatCurrencyType.Crypto} />
          </Grid>
        ))}
      </Grid>
    </Grid>
  );
};
